/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { linkCellRendererFactory } from '@gh/common-internal-shared';
import { createDialogRoute, getDialogInitData, NumberTypes } from '@gh/common-shared';
import { TranslationService } from '@gh/core-mls';
import { DialogInput } from '@gh/core-ui';
import { buildNumberColumn, GridDefinition, GridDefinitionFactory } from '@gh/core-ui-grid';
import {
  EmailCampaignListBusinessService,
  EmailCampaignReportDialogConfig,
} from '../../resources/email-campaign-list-business.service';
import { EmailCampaignReport } from '../../resources/email-campaigns.model';

@Component({
  selector: 'gh-email-campaign-report-dialog',
  template: require('./email-campaign-report-dialog.component.html'),
  styles: [require('./email-campaign-report-dialog.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailCampaignReportDialogComponent implements OnInit, DialogInput<EmailCampaignReportDialogConfig> {
  input: EmailCampaignReportDialogConfig;
  report: EmailCampaignReport;
  gridDefinition: GridDefinition;

  constructor(@Inject(MAT_DIALOG_DATA) private dialogData: any,
              private dialogRef: MatDialogRef<any>,
              private translations: TranslationService,
              private gridDefinitionFactory: GridDefinitionFactory) {
  }

  ngOnInit(): void {
    const { report } = getDialogInitData(this.dialogData);
    this.report = report;

    this.gridDefinition = this.gridDefinitionFactory.buildManual(
      [
        {
          headerName: this.translations.get('lbl_url'),
          width: 250,
          field: 'url',
          cellRenderer: linkCellRendererFactory('_blank'),
        },
        {
          ...buildNumberColumn(NumberTypes.Count),
          headerName: this.translations.get('lbl_total_clicks'),
          width: 100,
          field: 'totalClicks',
        },
        {
          ...buildNumberColumn(NumberTypes.Count),
          headerName: this.translations.get('lbl_unique_clicks'),
          width: 100,
          field: 'uniqueClicks',
        },
      ],
      {
        defaultColDef: {
          sortable: false,
        },
        noAutomation: true,
      },
    );
  }

  onClose(): void {
    this.dialogRef.close();
  }
}

export const emailCampaignReportDialogRoute = createDialogRoute({
  component: EmailCampaignReportDialogComponent,
  init: EmailCampaignListBusinessService,
});
